export default __webpack_public_path__ + "static/media/question.f7c15311.png";